var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "gate__link",
    class: {
      'gate__link--nolink': _vm.noLink
    },
    attrs: {
      "href": _vm.href,
      "tile": "",
      "elevation": "0"
    }
  }, [_c('div', {
    staticClass: "gate__link-thumb",
    style: 'background-image: url(' + _vm.bgImage + ')'
  }, [_c('div', {
    staticClass: "gate__link-thumb__inner"
  }, [_c('h4', {
    staticClass: "tit--sm white--text line-height-12 mb-10 mb-lg-14"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _vm.noLink ? _c('p', {
    staticClass: "page-text white--text font-weight-bold py-4 py-lg-10"
  }, [_vm._v(" 준비중입니다. ")]) : _c('v-btn', {
    staticClass: "w-100px w-lg-120px",
    attrs: {
      "tile": "",
      "outlined": "",
      "color": "white"
    }
  }, [_c('span', {
    staticClass: "page-text font-weight-bold"
  }, [_vm._v("바로가기")])])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }